<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">503</h1>
            <h4 class="pt-3">Oops! No tienes permiso para entrar a esta página.</h4>
            <p class="text-muted">
              No tienes permiso para entrar a esta pagina. Ponte en contacto con el administrador.
              <router-link to="/">Volver al inicio</router-link>
            </p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page500"
};
</script>
